const powerManage = () => import('@/view/powerManage/power-manage'); //
const apiManage = () => import('@/view/powerManage/api-manage'); //

export default [{
    path: '/power-manage',
    name: 'powerManage',
    component: powerManage
}, {
    path: '/api-manage',
    name: 'apiManage',
    component: apiManage
}];